import { Controller } from '@hotwired/stimulus'

// Top promo banner — permanent and non-dismissible, EXCEPT it yields to an
// OptinMonster floating (top) bar campaign so the two never stack:
//   - OptinMonster adds `om-position-floating-top` to <html> while its top bar
//     is active (and drives --popup-height / padding-top itself). While that
//     class is present the native banner is hidden via CSS (see promo-banner.sass)
//     and we drop our `data-popup-active` so we don't fight OptinMonster's offset.
//   - When the OptinMonster campaign is disabled, the class disappears and the
//     native banner returns automatically.
//
// OptinMonster loads/unloads asynchronously, so we watch the <html> class.
const POPUP_ATTR = 'data-popup-active'
const OM_TOP_BAR_CLASS = 'om-position-floating-top'

export default class extends Controller {
  connect() {
    this.sync = this.sync.bind(this)
    this.sync()
    this.observer = new MutationObserver(this.sync)
    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  sync() {
    if (document.documentElement.classList.contains(OM_TOP_BAR_CLASS)) {
      // An OptinMonster top bar is active — it owns the header offset.
      document.documentElement.removeAttribute(POPUP_ATTR)
    } else {
      document.documentElement.setAttribute(POPUP_ATTR, 'true')
    }
  }
}
